import { createFileRoute, Link } from "@tanstack/react-router";
import { ElectronicSignatureConsentBody, LEGAL_VERSIONS } from "@/lib/legal/documents";

export const Route = createFileRoute("/legal/electronic-signature-consent")({
  head: () => ({
    meta: [
      { title: "Electronic Signature Consent — Truck Company Center" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: ESignPage,
});

function ESignPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-12 md:px-6">
      <Link to="/" className="text-xs text-muted-foreground hover:text-foreground">← Inicio</Link>
      <h1 className="mt-3 font-display text-3xl font-semibold text-foreground md:text-4xl">
        Electronic Signature Consent
      </h1>
      <p className="mt-2 text-xs uppercase tracking-[0.18em] text-label-accent">
        Version {LEGAL_VERSIONS.electronic_signature_consent}
      </p>
      <div className="mt-6"><ElectronicSignatureConsentBody /></div>
    </div>
  );
}
